export class DependenciesController {
  constructor(param) {
    this.param = param;
    this._cyclicGraphDetected = false;
    this.methodDependencies = [];
  }
  set_error(message) {
    this.error_message = this.error_message || message;
  }
  reset() {
    this.param.graphDisconnectPredecessors();
    this.methodDependencies.forEach((methodDependency) => {
      methodDependency.reset();
    });
    this.methodDependencies = [];
  }
  update(functionGenerator) {
    this._cyclicGraphDetected = false;
    this._connectImmutableDependencies(functionGenerator);
    this.methodDependencies = functionGenerator.methodDependencies;
    this._handleMethodDependencies();
    this._listenForNameChanges();
  }
  _connectImmutableDependencies(function_generator) {
    function_generator.immutableDependencies.forEach((dependency) => {
      if (this._cyclicGraphDetected == false) {
        if (this.param.addGraphInput(dependency) == false) {
          this._cyclicGraphDetected = true;
          this.set_error("cannot create expression, infinite graph detected");
          this.reset();
          return;
        }
      }
    });
  }
  _handleMethodDependencies() {
    this.methodDependencies.forEach((methodDependency) => {
      if (this._cyclicGraphDetected == false) {
        this._handleMethodDependency(methodDependency);
      }
    });
  }
  _handleMethodDependency(method_dependency) {
    const node_simple = method_dependency.resolved_graph_node;
    if (node_simple) {
      if (!this.param.addGraphInput(node_simple)) {
        this._cyclicGraphDetected = true;
        this.set_error("cannot create expression, infinite graph detected");
        this.reset();
        return;
      }
    }
  }
  _listenForNameChanges() {
    this.methodDependencies.forEach((methodDependency) => {
      methodDependency.listen_for_name_changes();
    });
  }
}
